// extracted by mini-css-extract-plugin
export default {"loading-overlay":"LoadingSpinner_loading-overlay__JQOPi","spinner":"LoadingSpinner_spinner__b400N","spin":"LoadingSpinner_spin__x5nZI"};